<template>
  <div class="boards">Οι επιτροπές μου
    <el-select active-text-color="#ffd04b"   v-model="boardSelected" placeholder="Επιλέξτε Επιτροπή" v-loading="boardsLoading"  @change="fetchAssignedApplications">
      <el-option v-for="board in assignedExecutiveBoards"
      :label="board.boardsId + ' ' +'-' + ' ' +  board.boardsTitle"
      :key="board.boardsId" :value="board.boardsTitle">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import sharedMethods from '../common/sharedMethods.js'

export default {
  mixins: [sharedMethods],
  data () {
    return {
      boardSelected: null,
      currentLane: '',
      boardsLoading: false,
      assignedExecutiveBoards: '',
      boardsError: false
    }
  },
  mounted: function () {
    this.boardsLoading = true
    axios.get(`${this.BASE_URL}/executiveboardmembers/uid/boards`)
      .then((response) => {
        if (response.data.data !== undefined) {
          this.assignedExecutiveBoards = response.data.data.sort(function (a, b) { return (a.boardsId > b.boardsId) ? 1 : ((b.boardsId > a.boardsId) ? -1 : 0) })
        } else {
          this.assignedExecutiveBoards = [{boardsId: 404, boardsTitle: 'Ο χρήστης δεν ανήκει σε καμία Επιτροπή'}]
          this.boardsError = true
          this.$alert('Ο χρήστης δεν ανήκει σε καμία Επιτροπή', 'Προσοχη!', {
            confirmButtonText: 'OK'
          })
        }
        this.boardsLoading = false
      }, (err) => {
        this.backendError(err)
        this.boardsLoading = false
      })
  },
  computed: {
    ...mapState([
      'activeLane',
      'assignedApplications',
      'workingApplication',
      'showWorkingApplication',
      'loadingAssignedApplications',
      'BASE_URL'
    ])
  },
  methods: {
    fetchAssignedApplications () {
      let boardId = this.assignedExecutiveBoards.find(board => board.boardsTitle === this.boardSelected).boardsId
      this.currentLane = 'boards/' + boardId
      this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.currentLane)
    },
    boardIndexId (id) {
      return `1-${id + 1}`
    }
  },
  watch: {
  }
}
</script>
<style lang='scss' scoped>
div {
    word-wrap: normal;
}
.boards {
  padding: 20px;
  margin: 10px;
  background-color: #f5f7fa;
  width: 650px;
}
// .el-input__inner {
//   width: 400px;
// }
.el-select {
  width: 500px
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/ExecutiveBoardMemberMenu.vue